goog.provide("shadow.js.shim.module$$mui$material$Skeleton");
goog.provide("module$shadow_js_shim_module$$mui$material$Skeleton");
shadow.js.shim.module$$mui$material$Skeleton = shadow.js.nativeProvides["@mui/material/Skeleton"] = shadow$bridge("@mui/material/Skeleton");
module$shadow_js_shim_module$$mui$material$Skeleton.default = shadow.js.shim.module$$mui$material$Skeleton;
